let PlacesService = require('./places-service');

module.exports = {
  PlacesService
};



// WEBPACK FOOTER //
// ./node_modules/tortilla/src/maps/places/index.js